export const fmtNum = (n) => {
  if (n === null || n === undefined) return "—";
  if (typeof n === "string") return n;
  if (Math.abs(n) >= 1_000_000_000) return (n / 1_000_000_000).toFixed(2) + " B";
  if (Math.abs(n) >= 1_000_000) return (n / 1_000_000).toFixed(2) + " M";
  if (Math.abs(n) >= 10_000) return Math.round(n / 1000) + " K";
  if (Math.abs(n) >= 1_000) return n.toLocaleString();
  return n.toString();
};

export const fmtInt = (n) => (n === null || n === undefined ? "—" : n.toLocaleString());

export const fmtBytesTb = (tb) => (tb === null || tb === undefined ? "—" : tb + " TB");

export const fmtSecAgo = (sec) => {
  if (sec == null) return "—";
  if (sec < 60) return `${sec} sec ago`;
  if (sec < 3600) return `${Math.floor(sec / 60)} min ago`;
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  return `${h} hr ${m} min ago`;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString();
  } catch {
    return iso;
  }
};

export const statusClass = (s) => {
  if (!s) return "";
  const k = s.toLowerCase().replace(/\s+/g, "-");
  return `status-${k}`;
};

/** RAG threshold — same rules as Control Assurance:
 *   Red (Non-compliant): score < 90
 *   Amber (At risk):     90 ≤ score < 95
 *   Green (Compliant):   score ≥ 95
 */
export const ragTone = (score) => {
  if (score == null || Number.isNaN(score)) return "var(--cv-slate)";
  if (score < 90) return "var(--cv-crimson)";
  if (score < 95) return "#E5C243";
  return "var(--cv-green)";
};

export const ragLabel = (score) => {
  if (score < 90) return "Non-compliant";
  if (score < 95) return "At risk";
  return "Compliant";
};

export const ragPillClass = (score) => {
  if (score < 90) return "status-non-compliant";
  if (score < 95) return "status-at-risk";
  return "status-compliant";
};
